import React from 'react'
import Link from 'gatsby-link'
import { elastic as Menu } from 'react-burger-menu'

class header extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false
    }
  }
  // This keeps your state in sync with the opening/closing of the menu
  // via the default means, e.g. clicking the X, pressing the ESC key etc.
  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})
  }
  // This can be used to close the menu, e.g. when a user clicks a menu item
  closeMenu () {
    this.setState({menuOpen: false})
  }
  // This can be used to toggle the menu, e.g. when using a custom icon
  // Tip: You probably want to hide either/both default icons if using a custom icon
  toggleMenu () {
    this.setState({menuOpen: !this.state.menuOpen})
  }
  render () {
    return (
      <Menu
        pageWrapId={ "page-wrap" }
        outerContainerId={ "outer-container" }
        isOpen={this.state.menuOpen}
        onStateChange={(state) => this.handleStateChange(state)}
      >
        <Link className="menu-item" to="/" onClick={() => this.closeMenu()}>Home</Link>
        <Link className="menu-item" to="/about/" onClick={() => this.closeMenu()}>About</Link>
        <Link className="menu-item" to="/services/" onClick={() => this.closeMenu()}>Services</Link>
        <Link className="menu-item" to="/case-studies/" onClick={() => this.closeMenu()}>Case Studies</Link>
        <Link className="menu-item" to="/blog/" onClick={() => this.closeMenu()}>Blog</Link>
        <Link className="menu-item" to="/contact/" onClick={() => this.closeMenu()}>Contact</Link>
      </Menu>
    );
  }
}

export default header



// WEBPACK FOOTER //
// ./src/components/Header/index.js